import request from '@/utils/request'
import md5 from 'md5'
// 手机号+密码注册
export function fetchRegister(data) {
  return request({
    url: `/api/v1/register/phonewithpasswd?phone=${data.phone}&telAreaCode=${data.telAreaCode}&passwd=${md5(data.passwd)}`,
    baseURL: 'other',
    method: 'post',
    data
  })
}
